<div class="users-header">
  <wm-common-text [data]="{ text: 'Settings' }" class="header"></wm-common-text>
</div>

<div class="tabs-wrapper">
  <button
    [style.background]="'none'"
    [style.border]="'none'"
    *ngIf="canScrollLeft"
    [class.disabled]="!canScrollLeft"
    [disabled]="!canScrollLeft"
    (click)="scrollTabs('left')"
  >
    <span class="mobile-arrow material-icons">keyboard_arrow_left </span>
  </button>

  <div class="tabs" #tabsContainer (scroll)="onTabsScroll()">
    <div
      class="tab"
      [class.active]="activeTab === 'general'"
      (click)="switchTab('general')"
    >
      General
    </div>

    <div
      *ngIf="canManageDepartments"
      class="tab"
      [class.active]="activeTab === 'departments'"
      (click)="switchTab('departments')"
    >
      Departments
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'import-previous-system'"
      (click)="switchTab('import-previous-system')"
    >
      Previous System
    </div>
    <div
      *ngIf="isSysAdmin"
      class="tab"
      [class.active]="activeTab === 'workflow-migration'"
      (click)="switchTab('workflow-migration')"
    >
      Migrate Workflow
    </div>

    <div
      *ngIf="isSysAdmin"
      class="tab"
      [class.active]="activeTab === 'migrate-contractors'"
      (click)="switchTab('migrate-contractors')"
    >
      Migrate Contractors
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'maps'"
      (click)="switchTab('maps')"
    >
      Map Services
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'payment-settings'"
      (click)="switchTab('payment-settings')"
    >
      Payments
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'data'"
      (click)="switchTab('data')"
    >
      Data Connections
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'custom-lists'"
      (click)="switchTab('custom-lists')"
    >
      Custom Lists
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'email-settings'"
      (click)="switchTab('email-settings')"
    >
      Email Settings
    </div>

    <button
      type="button"
      *ngIf="isSysAdmin"
      class="tab"
      style="background: none; border: 0;"
      [class.active]="activeTab === 'archive-data'"
      (click)="switchTab('archive-data')"
    >
      Archive Data
    </button>

    <div
      class="tab"
      [class.active]="activeTab === 'contacts'"
      (click)="switchTab('contacts')"
    >
      Contacts
    </div>

    <div
      class="tab"
      [class.active]="activeTab === 'tags'"
      (click)="switchTab('tags')"
    >
      Tags
    </div>
  </div>

  <button
    [style.background]="'none'"
    [style.border]="'none'"
    *ngIf="hasOverflow"
    [class.disabled]="!canScrollRight"
    [disabled]="!canScrollRight"
    (click)="scrollTabs('right')"
  >
    <span class="mobile-arrow material-icons">keyboard_arrow_right </span>
  </button>
</div>

<div class="tab-content" #tabContentContainer>
  <router-outlet></router-outlet>

  <!-- <wm-workflow-migration *ngIf="activeTab === 'workflow-migration'"></wm-workflow-migration> -->
</div>
